import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import {
  ModalSize,
  SuiModalService,
  ModalTemplate,
  TemplateModalConfig,
} from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import {
  UserDetailModal,
  FieldChangeModal,
} from 'src/modules/features/admin/modals';
import { DOCUMENT } from '@angular/common';
import { RoleService } from '../../../services';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  OrganizationService,
  UserService,
} from 'src/modules/features/admin/services';
import { environment } from 'src/environments/environment';
interface IDynamicFormContext {
  formStructure: Array<any>;
  formTitle?: string;
  formAction?: string;
  companyTypeOptions?: any;
  prbsOptions?: Array<any>;
}
@Component({
  selector: 'app-company-user',
  templateUrl: './company-user.component.html',
  styleUrls: ['./company-user.component.scss'],
})
export class CompanyUserComponent implements OnInit {
  @ViewChild('roleModalTemplate') public roleModalTemplate: ModalTemplate<
    IDynamicFormContext,
    string,
    string
  >;
  @ViewChild('inviteModalTemplate') public inviteModalTemplate: ModalTemplate<
    IDynamicFormContext,
    string,
    string
  >;
  @ViewChild('inviteMultipleModalTemplate')
  public inviteMultipleModalTemplate: ModalTemplate<
    IDynamicFormContext,
    string,
    string
  >;

  @ViewChild('copyInvitationModalTemplate')
  public copyInvitationModalTemplate: ModalTemplate<
    IDynamicFormContext,
    string,
    string
  >;

  @ViewChild('assignUserModalTemplate')
  public assignUserModalTemplate: ModalTemplate<
    IDynamicFormContext,
    string,
    string
  >;

  @ViewChild('editModalTemplate') public editModalTemplate: ModalTemplate<
    IDynamicFormContext,
    string,
    string
  >;

  @ViewChild('assignQuestionModalTemplate')
  public assignQuestionModalTemplate: ModalTemplate<
    IDynamicFormContext,
    string,
    string
  >;

  users = [];
  projectId: string;
  workflowFields = [];
  success: any;
  error: any;
  pending: boolean;
  usersParams: AppFilter = new AppFilter();
  rolesParams: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  realApplications: Array<any> = [];
  // search usersParams (contains dataType and seach index on dataName)
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'appUserEmail',
        op: 'cn',
        data: '',
      },
      {
        field: 'username',
        op: 'cn',
        data: '',
      },
      {
        field: 'firstName',
        op: 'cn',
        data: '',
      },
      {
        field: 'lastName',
        op: 'cn',
        data: '',
      },
    ],
  };
  baseUrl: string = environment.API_SERVER;
  user: any;
  organizationId: string;
  admin: boolean;
  tokenToCopy: any;
  selectedUser: any;
  applicationsIds: any = {};
  roleForm: FormGroup;
  userForm: FormGroup;
  multiUserForm: FormGroup;
  userApplications: Array<any> = [];
  applications: Array<any> = [];
  currentRole;
  roles: Array<any> = [];
  permissions: Array<any> = [];
  departments: Array<any> = [];
  inviteApplications: Array<any> = [];
  InviteRoles: Array<any> = [];
  InviteDepartments: Array<any> = [];
  allusers2FA: boolean = false;
  organization;
  constructor(
    @Inject(DOCUMENT) private document,
    private modalService: SuiModalService,
    private location: Location,
    private roleSvc: RoleService,
    private activatedRoute: ActivatedRoute,
    private organizationSvc: OrganizationService,
    private fb: FormBuilder,
    private userSvc: UserService
  ) {
    this.multiUserForm = fb.group({
      emails: ['', Validators.required],
      role: ['', Validators.required],
      department: ['', Validators.required],
      application: ['', Validators.required],
    });
    this.userForm = fb.group({
      email: ['', Validators.required],
      role: ['', Validators.required],
    });
    this.roleForm = fb.group({
      role: ['', [Validators.required]],
    });
    // initialize  data usersParams
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.organizationId = window.localStorage.getItem('organizationId');
    this.organization = JSON.parse(window.localStorage.getItem('organization'));

    this.usersParams = new AppFilter({ sidx: 'dateCreated' });
    this.rolesParams = new AppFilter({ sidx: 'roleName', rows: 3000 });
    this.getPage(this.usersParams.page);
    this.getRole();
    const role = this.user.organizationId.organizationTypeId.organizationTypeId;
    if (role === 'system_collaborator' || role === 'system_admin') {
      this.admin = true;
      this.getApplications();
    } else {
      this.realApplications = this.user.applications;
      console.log(this.realApplications);
    }
    // this.activatedRoute.parent.params.subscribe((params) => {
    // 	this.projectId = params['id'];
    // });
    if (window.localStorage.getItem('permission')) {
      this.permissions = JSON.parse(window.localStorage.getItem('permission'));
    }
    // this.getInviteApplications();
  }
  performAll2FA(user) {
    this.toggle2FA(user);
  }
  toggle2FA(user) {
    this.modalService
      .open(
        new ConfirmModal(
          `${!user.totpEnabled ? 'Disable 2FA' : 'Enable 2FA'}`,
          `Are you sure you want to ${
            !user.totpEnabled ? 'Disable 2FA' : 'Enable 2FA'
          } for all user?`,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.changeToggle2Fa();
      })
      .onDeny(() => {
        console.log(this.organization.totpEnabled);
        this.organization.totpEnabled = !this.organization.totpEnabled;
      });
  }
  changeToggle2Fa() {
    this.error = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .toggleAdmin2FactorA({
        organizationId: this.organizationId,
      })
      .subscribe(
        (res) => {
          // this.pending = false;
          this.success = 'Organization 2FA enabled successfully';
          this.organization.totpEnabled = this.organization.totpEnabled;
          window.localStorage.setItem(
            'organization',
            JSON.stringify(this.organization)
          );
          setTimeout(() => {
            this.getPage(this.usersParams.page);
          }, 200);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  perform2FA(user) {
    user.totpEnabled ? this.enable2FA(user) : this.disable2FA(user);
  }
  enable2FA(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Enable 2FA?',
          'Are you sure you want to enable 2FA for this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.changeEnable2Fa({ user: user });
      })
      .onDeny(() => {
        user.totpEnabled = false;
      });
  }
  disable2FA(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Disable 2FA?',
          'Are you sure you want to disable 2FA for this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.changeDisable2Fa({ user: user });
      })
      .onDeny(() => {
        user.totpEnabled = true;
      });
  }
  reset2FA(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Reset 2FA?',
          'Are you sure you want to reset 2FA for this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.changeReset2Fa({ user: user });
      })
      .onDeny(() => {});
  }
  changeEnable2Fa(values) {
    this.error = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .enable2FactorA({
        appUserId: values.user.appUserId,
      })
      .subscribe(
        (res) => {
          // this.pending = false;
          this.success = 'User 2FA enabled successfully';
          setTimeout(() => {
            this.getPage(this.usersParams.page);
          }, 200);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  changeDisable2Fa(values) {
    this.error = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .disable2FactorA({
        appUserId: values.user.appUserId,
      })
      .subscribe(
        (res) => {
          // this.pending = false;
          this.success = 'User 2FA disabled successfully';
          setTimeout(() => {
            this.getPage(this.usersParams.page);
          }, 200);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  changeReset2Fa(values) {
    this.error = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .reset2FactorA({
        appUserId: values.user.appUserId,
      })
      .subscribe(
        (res) => {
          // this.pending = false;
          this.success = 'User 2FA reset successfully';
          setTimeout(() => {
            this.getPage(this.usersParams.page);
          }, 200);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  checkPermission(id: string, action: string): boolean {
    const result = this.permissions.filter((res) => res.permissionId === id);
    return result.length > 0 && result[0][action] === 'true';
  }
  setApp(op, id) {
    if (op === 'add') {
      this.applicationsIds[id] = id;
    } else {
      delete this.applicationsIds[id];
    }
  }
  changeRole(values) {
    this.error = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.success = null;
    this.organizationSvc
      .changeUserRole({
        organizationId: this.organizationId,
        appUserEmail: values.email,
        roleName: values.role,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User role updated successfully';
          setTimeout(() => {
            this.getPage(this.usersParams.page);
          }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  changeStatus(values) {
    this.error = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .changeUserStatus({
        organizationId: this.organizationId,
        appUserId: values.user.appUserId,
        status: values.status,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User status updated successfully';
          setTimeout(() => {
            this.getPage(this.usersParams.page);
          }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  verificationStatusChange(values) {
    this.error = null;
    this.pending = true;
    this.success = null;
    this.organizationSvc
      .verificationStatusChange({
        appUserId: values.user.appUserId,
        status: values.status,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User verification status updated successfully';
          setTimeout(() => {
            this.getPage(this.usersParams.page);
          }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getRole() {
    const searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'organizationId.organizationId',
          op: 'ne',
          data: this.organizationId,
        },
      ],
    };
    // this.rolesParams.filters = JSON.stringify(searchFilter);
    this.roleSvc
      .getRoles({
        organizationId: this.organizationId,
        params: this.rolesParams,
      })
      .subscribe(
        (res: any[]) => {
          //   this.pending = false;
          this.roles = res['rows'];
        },
        (error) => {
          //   this.roleLoading = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getDepartments() {
    this.pending = true;
    this.organizationSvc.getDepartments().subscribe(
      (res: any) => {
        this.InviteDepartments = res['rows'];
        this.pending = false;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }

  getRoleForDepartment() {
    this.pending = true;
    this.organizationSvc.getRoleFoDepartment().subscribe((res: any) => {
      this.InviteRoles = res['rows'];
    });
  }

  getInviteApplications() {
    const searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'hideFromDashboard',
          op: 'eq',
          data: false,
        },
        {
          field: 'applicationId',
          op: 'ne',
          data: 'default',
        },
      ],
    };
    const searchBy = JSON.stringify(searchFilter);
    const params = new AppFilter({
      sidx: 'dateCreated',
      rows: 1000,
      filters: searchBy,
    });
    console.log(params);
    this.organizationSvc
      .getApplications({ params: params })
      .subscribe((res) => {
        this.inviteApplications = res['rows'];
      });
  }
  getApplications() {
    const searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'hideFromDashboard',
          op: 'eq',
          data: false,
        },
      ],
    };
    const searchBy = JSON.stringify(searchFilter);
    const params = new AppFilter({
      sidx: 'dateCreated',
      rows: 1000,
      filters: searchBy,
    });
    this.organizationSvc
      .getApplications({ params: params })
      .subscribe((res) => {
        this.realApplications = res['rows'];
      });
  }
  getPage(page) {
    this.usersParams.page = page;
    this.pending = true;
    this.organizationSvc
      .getUsers({
        organizationId: this.organizationId,
        params: this.usersParams,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.usersParams.rows;
          this.users = res['rows'];
          console.log('users ', this.users);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'appUserEmail',
          op: 'cn',
          data: '',
        },
        {
          field: 'firstName',
          op: 'cn',
          data: '',
        },
        {
          field: 'lastName',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    searchFilter.rules[1].data = search;
    searchFilter.rules[2].data = search;
    this.usersParams.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.usersParams.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.usersParams['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  sendMultipleInvite(values) {
    this.error = null;
    // this.errorInvite = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .inviteExternalAppUsers({
        rileId: values.rileId,
        body: values.body,
        organizationId: values.organizationId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Invitation has been sent successfully';
          this.user = res['data'];
          // setTimeout(() => {
          //   this.getPage(this.usersParams.page);
          //   if (this.user !== undefined) {
          //     this.assginQuestion(this.user);
          //   }
          // }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  sendInvitation(values) {
    this.error = null;
    // this.errorInvite = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .inviteUsers({
        organizationId: this.organizationId,
        body: { ids: [values.ids] },
        roleName: values.role,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Invitation has been sent successfully';
          this.user = res['data'];
          setTimeout(() => {
            this.getPage(this.usersParams.page);
            if (this.user !== undefined) {
              this.assginQuestion(this.user);
            }
          }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  assginQuestion(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Assign Application',
          'Would you like to assign application(s) to the user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.popAssignFUser(user);
      })
      .onDeny(() => {});
  }

  checkApps(appId) {
    return (
      this.userApplications.find((applicationId) => applicationId === appId) !==
      undefined
    );
  }

  popInviteUser() {
    const config = new TemplateModalConfig<IDynamicFormContext, string, string>(
      this.inviteModalTemplate
    );
    // config.mustScroll = false;
    config.isClosable = false;
    config.transitionDuration = 200;
    config.transition = 'slide left';
    config.size = ModalSize.Tiny;
    config.isFullScreen = false;
    config.isInverted = false;
    this.modalService
      .open(config)
      .onApprove(() =>
        this.sendInvitation({
          ids: this.userForm.value.email.trim(),
          role: this.userForm.value.role,
        })
      )
      .onDeny(() => {});
  }
  popAssignFUser(usr) {
    console.log('coming from clicked', usr);
    let user = this.users.filter((user) => user.appUserId == usr[0])[0];
    if (user) {
      this.userApplications = user.applications;
      console.log('Selected user apps', user.applications);
    }
    // const userApps = user.applications.map(app => app.applicationId);
    this.selectedUser = user;
    const dumbApps = this.realApplications;
    dumbApps.forEach((apps) => {
      const id = apps.applicationId;
      apps['allowed'] = 'true';
      return apps;
    });
    this.applications = dumbApps;
    console.log(this.applications);
    console.log('dumbs app', dumbApps);
    if (this.userApplications.length > 0) {
      this.userApplications.forEach((app) => {
        this.applicationsIds[app.applicationId] = app.applicationId;
      });
    }

    const config = new TemplateModalConfig<IDynamicFormContext, string, string>(
      this.assignUserModalTemplate
    );
    // config.mustScroll = false;
    config.isClosable = false;
    config.transitionDuration = 200;
    config.transition = 'slide left';
    config.size = ModalSize.Tiny;
    config.isFullScreen = false;
    config.isInverted = false;
    this.modalService
      .open(config)
      .onApprove((role) => this.assignUser())
      .onDeny(() => {
        this.userApplications = [];
        this.userApplications.length = 0;
      });
  }

  popAssignUser(user) {
    console.log('coming from clicked', user);
    this.userSvc
      .getUserApps({ appUserId: user.appUserId })
      .subscribe((res: any) => {
        // const userApps = user.applications.map(app => app.applicationId);
        this.userApplications = res;
        // const userApps = user.applications.map(app => app.applicationId);
        this.selectedUser = user;
        const dumbApps = this.realApplications;
        dumbApps.forEach((apps) => {
          const id = apps.applicationId;
          apps['allowed'] = 'true';
          return apps;
        });
        this.applications = dumbApps;

        res.forEach((app) => {
          this.applicationsIds[app] = app;
        });

        const config = new TemplateModalConfig<
          IDynamicFormContext,
          string,
          string
        >(this.assignUserModalTemplate);
        // config.mustScroll = false;
        config.isClosable = false;
        config.transitionDuration = 200;
        config.transition = 'slide left';
        config.size = ModalSize.Tiny;
        config.isFullScreen = false;
        config.isInverted = false;
        this.modalService
          .open(config)
          .onApprove((role) => this.assignUser())
          .onDeny(() => {
            this.userApplications = [];
            this.userApplications.length = 0;
          });
      });
  }

  assignUser() {
    if (this.admin) {
      this.adminAssignApps();
    } else {
      this.assignApps();
    }
  }

  assignApps() {
    this.pending = true;
    const id = 'default';
    this.applicationsIds[id] = id;
    this.organizationSvc
      .assignApplications({
        organizationId: this.organizationId,
        appUserId: this.selectedUser.appUserId,
        body: { ids: Object.keys(this.applicationsIds) },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User application access operation was successful';
          this.applications = [];
          this.applicationsIds = {};
          this.selectedUser = null;
          this.getPage(this.usersParams.page);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  adminAssignApps() {
    this.pending = true;
    const id = 'default';
    this.applicationsIds[id] = id;
    this.organizationSvc
      .adminAssignApplications({
        organizationId: this.organizationId,
        appUserId: this.selectedUser.appUserId,
        body: { ids: Object.keys(this.applicationsIds) },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User application access operation was successful';
          this.applications = [];
          this.applicationsIds = {};
          this.selectedUser = null;
          this.getPage(this.usersParams.page);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  sendInvitation2(values) {}

  copyInvitationModal() {
    const config = new TemplateModalConfig<IDynamicFormContext, string, string>(
      this.copyInvitationModalTemplate
    );
    config.mustScroll = false;
    this.modalService
      .open(config)
      .onApprove(() => {
        this.copyToClipboard();
      })
      .onDeny(() => {});
  }

  resendInvitation(values) {
    this.error = null;
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .resendEmailInvitation({
        organizationId: this.organizationId,
        appUserEmail: values.appUserId,
      })
      .subscribe(
        (res) => {
          this.success = 'Re-invitation successful';
          this.tokenToCopy = res['token'];
          console.log('TOKEN ', res);
          this.copyInvitationModal();
          this.getPage(this.usersParams.page);
        },
        (error) => {
          console.log('error ', error);
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  copyToClipboard() {
    var dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = `${environment.WEB}/home-page/invitation?token=${this.tokenToCopy}`;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);

    // this.sweetaleart('Link copied successfully', 'success');
  }
  inviteUser(user) {}
  viewUser(user) {
    this.modalService
      .open(new UserDetailModal('User Detail', user, ModalSize.Tiny))
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }

  inviteMulti() {
    this.getRoleForDepartment();
    this.getInviteApplications();
    this.getDepartments();

    const config = new TemplateModalConfig<IDynamicFormContext, string, string>(
      this.inviteMultipleModalTemplate
    );
    config.isClosable = false;
    config.transitionDuration = 200;
    config.transition = 'slide left';
    config.size = ModalSize.Tiny;
    config.isFullScreen = false;
    config.isInverted = false;
    this.modalService
      .open(config)
      .onApprove((role) =>
        this.sendMultipleInvite({
          email: this.multiUserForm.value.email.trim(),
          role: this.multiUserForm.value.role,
        })
      )
      .onDeny(() => console.log('hello'));
  }

  roleModal(data) {
    this.currentRole = data.roleId.roleId;
    const config = new TemplateModalConfig<IDynamicFormContext, string, string>(
      this.roleModalTemplate
    );
    config.isClosable = false;
    config.transitionDuration = 200;
    config.transition = 'slide left';
    config.size = ModalSize.Tiny;
    config.isFullScreen = false;
    config.isInverted = false;
    this.modalService
      .open(config)
      .onApprove((role) =>
        this.changeRole({ email: data.appUserId, role: this.currentRole })
      )
      .onDeny(() => console.log('hello'));
    // this.router.navigate(["/collaborator/validation/data/edit"])
  }

  reactivateUser(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Activate User?',
          'Are you sure you want to activate this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.changeStatus({ user: user, status: true });
      })
      .onDeny(() => {});
  }

  resendInvite(app) {
    this.modalService
      .open(
        new ConfirmModal(
          'Resend Invitation?',
          'Are you sure you want to resend invitation to this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.resendInvitation(app);
      })
      .onDeny(() => {});
  }

  deactivateUser(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Deactivate User?',
          'Are you sure you want to deactivate this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.changeStatus({ user: user, status: false });
      })
      .onDeny(() => {});
  }

  assignApplication(app) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove User?',
          'Are you sure you want to remove this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  assignDepartment(app) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove User?',
          'Are you sure you want to remove this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  deleteUser(app) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove User?',
          'Are you sure you want to remove this user?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.delete(app);
      })
      .onDeny(() => {});
  }

  delete(data) {
    this.pending = true;
    this.error = null;
    this.success = null;
    this.organizationSvc
      .removeUser({
        organizationId: this.organizationId,
        appUserEmail: data.appUserId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'User removed successfully';
          setTimeout(() => {
            this.getPage(this.usersParams.page);
          }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.message
            ? error.error.message
            : error.error
            ? error.error
            : error;
        }
      );
  }
  goBack() {
    this.location.back();
  }

  ngOnInit(): void {}
}
